
import { Options, Vue } from "vue-class-component";
import CadastroRntrcSolicitacao from "../../components/rntrc/CadastroRntrcSolicitacao.vue";

@Options({
  props: {
    idRntrcSolicitacao: Number,
    tipo: String,
    idOrigem: Number,
    idsVeiculosOrigem: Array
  },
  components: {
    CadastroRntrcSolicitacao
  }
})
export default class RntrcNovaSolicitacao extends Vue {
  idRntrcSolicitacao?: number;
  tipo?: string;
  idOrigem?: number;
  idsVeiculosOrigem?: Array<number>;
}
